import { EDITINVOICE_SUCCESS, EDITINVOICE_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const editInvoiceReducer = (state = initialState, action) => {
    switch (action.type) {
        case EDITINVOICE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case EDITINVOICE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default editInvoiceReducer;
